import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventActivityCreated } from 'entities/Activity/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseEventActivityCreated) => void

export const useEventActivityCreated = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.ConversationsActivityCreated, handler), [handler])
}
